import * as yup from 'yup';
import { equals } from 'ramda';
import { cFormValidationMessages } from '../../constants/validationMessages';

export const cFieldNames = {
    name: 'name',
    layoutId: 'layoutId',
    dangerousFindings: 'dangerousFindings',
    loginRequired: 'loginRequired',
    observedPersonRequired: 'observedPersonRequired',
};

export const validationSchema = (t: any) => {
    return yup.object().shape({
        [cFieldNames.name]: yup.string().required(t(cFormValidationMessages.required)),
    });
};
